<!-- 商户详情主栏目 -->
<template>
  <div class="comContent main-box">
    <div class="main-title">
      <div>
        <MyTabs class="search" :tabi="tabsVal" keyname="val" :tabs="tabsData" @change="tabChange" />
      </div>
      <div>
        <MyButton type="defalut" icon="el-icon-back" text="返回" @click="goBack" />
      </div>
    </div>
    <div class="main-content">
      <!-- <component :ref="tabsVal" :mId="id" :is="tabsVal"></component> -->
      <ShopQualificaiotn v-if="tabsVal == 'ShopQualificaiotn'"/>
      <CommodityOpsList pageSoucre="shopLookByAdmin"  v-else-if="tabsVal == 'CommodityOpsList'" ref="commodityOpsListRef" />
      <ReconciliationForOps v-else-if="tabsVal == 'ReconciliationForOps'" ref="reconciliationForOpsRef"/>
      <OperationSituation v-else-if="tabsVal == 'OperationSituation'" />
      <MoneyLog v-else-if="tabsVal == 'moneyLog'" />
      <MarginIn v-else-if="tabsVal == 'MarginIn'" />
      <AfterSale v-else-if="tabsVal == 'AfterSale'" />
      <OrderList v-else-if="tabsVal == 'OrderList'" />
    </div>
  </div>
</template>

<script>

import MyButton from '@/components/myButton';
import MyTable from '@/components/myTable';
import MyTabs from '@/components/myTabs';

import qualification from './components/qualification.vue';
import goods from './components/goods.vue';
// 订单
import OrderList from './components/orderList.vue';
// 售后单据
import AfterSale from './components/afterSale.vue';
// 保证金
import MarginIn from './components/marginIn.vue';
import statementLog from './components/statementLog.vue';
// 收入记录
import MoneyLog from './components/moneyLog.vue';
// 运营情况
import OperationSituation from './components/operationSituation.vue';
// 店铺资质信息
import ShopQualificaiotn from  '@/views/qualification/audit/detail.vue'
// 商品列表
import CommodityOpsList from '@/views/commodityOpsList/index.vue'
// 对账单
import ReconciliationForOps from "@/views/businessManage/shop/componnet/reconciliationForOps.vue";

export default {
  name:'MainMerchant',
  components: {
    MyButton, MyTable, MyTabs,
    qualification,goods,OrderList,AfterSale,MarginIn,statementLog,MoneyLog,OperationSituation,
    CommodityOpsList,ReconciliationForOps,ShopQualificaiotn
  },
  data() {
    return {
      tabsData: [
        { name: '资质', num: 0, val: 'ShopQualificaiotn', numhide: true },
        { name: '商品', num: 0, val: 'CommodityOpsList', numhide: true },
        { name: '订单', num: 0, val: 'OrderList', numhide: true },
        { name: '售后单据', num: 0, val: 'AfterSale', numhide: true },
        { name: '保证金', num: 0, val: 'MarginIn', numhide: true },
        { name: '对账单', num: 0, val: 'ReconciliationForOps', numhide: true },
        { name: '收入记录', num: 0, val: 'moneyLog', numhide: true },
        { name: '运营情况', num: 0, val: 'OperationSituation', numhide: true },
      ],
      tabsVal: 'qualification',
      shopId:'',//商户id
    };
  },
  computed: {
    tabsName(){
      return this.$store.state.user.merchantTabName;
    }
  },
  // watch: {},
  created() {
    // merchantTabName
    // console.log('tabsName',this.tabsName)
    this.tabsVal = this.tabsName || this.tabsData[0].val; // 保持页面返回时回到上一个栏目
    let query = this.$route.query;
    if(query.shopId){
      this.shopId = query.shopId;
    }else{
      // console.log('获取商户id为空，自动跳转商户列表')
      this.goBack();
    }
  },
  mounted() {},
  methods: {
    tabChange (val) {
      console.log(val)
      this.tabsVal = val;
      this.$store.dispatch('user/setMTabName', val)
      switch (val) {
        case 'CommodityOpsList':
          
        break;
        case 'ReconciliationForOps':
          this.$nextTick(()=>{
              this.$refs['reconciliationForOpsRef'].getList(this.shopId)
          })
        default:
          break;
      }
    },
    goBack () {
      // console.log('go back');
      this.$router.push("/reportMerchant/reportMerchant-reportList");

      // this.$router.go(-1)：后退+刷新；
      // this.$router.go(0)：刷新；
      // this.$router.go(1) ：前进
      // this.$router.back(); //:后退
      // this.$router.back(0) 刷新；
      // this.$router.back(1)：前进
    },
    // goLink(type="1"){
    //   let url = type==1?'/reportCustomer/reportCustomer-reportDetail':'/reportCustomer/reportCustomer-reportDetailMore'
    //   this.$router.push(url);
    // }
  },
  // beforeCreate() { },
  // beforeMount() { },
  // beforeUpdate() { },
  // updated() { },
  // beforeDestroy() { },
  // destroyed() { },
  // activated() { },
}
</script>
<style lang='scss' scoped>
.main{
  &-box{
    padding: 0px;
  }
  &-title{
    height: 56px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f5f5ff;
  }
  &-content{
    margin: 16px 8px 0 16px;
    padding-right: 8px;
    height: calc(100% - 80px);
    overflow-y: auto;
  }
}
</style>
